// ログイン切れの検知（本城さん報告 2026-09-07 の再発防止）
//
// セッションは30日で切れるが、タブを開いたまま期限を越えると、アプリは再ログインを求めず
// 手元（localStorage）だけで動き続けていた。共有への保存はすべて 401 で失敗し、ヘッダの
// 黄色いピル「共有していません」が出るだけだったため、徳永さんが取り込んだ8月分が
// 誰にも届かないまま作業が進んだ。
//
// ここでは「API が 401（authRequired）を返した」ことを1か所に集め、AuthGate に知らせる。
// AuthGate は通知を受けるとログイン画面に戻す（作業中の内容は localStorage に残る）。

const EVENT_NAME = "hsd:auth-required";

// API 応答がログイン切れなら AuthGate に知らせて true を返す。
// data は JSON を読んだ後の本文（読んでいなければ省略可）。
export function noteAuthRequired(r: Response, data?: unknown): boolean {
  const flagged = !!data && typeof data === "object" && (data as { authRequired?: boolean }).authRequired === true;
  if (r.status !== 401 && !flagged) return false;
  if (typeof window !== "undefined") window.dispatchEvent(new Event(EVENT_NAME));
  return true;
}

export function onAuthRequired(cb: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(EVENT_NAME, cb);
  return () => window.removeEventListener(EVENT_NAME, cb);
}
